<!--
 * @Description: 
 * @Author: luckymiaow
 * @Date: 2022-04-29 15:08:29
 * @LastEditors: luckymiaow
-->
<script lang="ts">
import { computed, defineComponent, provide, ref } from 'vue';
import type { FormInstance } from 'ant-design-vue';
import { Form as AForm } from 'ant-design-vue';
import useConfigProvider from '../../config-provider/src/useConfigProvider';
import type { FormBaseInjectConfig, FormConfig } from '../types';
import { formProvideKey } from './useFormConfig';

export default defineComponent({
  components: { AForm },
  props: {
    readOnly: Boolean,
    bordered: { type: Boolean, default: true },
    readOnlyStyle: Object,
    readOnlyClassName: String,
  },
  setup(props: FormConfig) {
    const { injectConfig } = useConfigProvider();

    const getBindValue = computed(() => ({
      ...injectConfig<FormBaseInjectConfig>('form')?.value,
    }));

    provide(formProvideKey, props);

    const elRef = ref<FormInstance>();

    return { getBindValue, elRef };
  },
});
</script>

<template>
  <AForm v-bind="getBindValue" ref="elRef">
    <slot></slot>
  </AForm>
</template>
